import { createConnectQuery } from '@jotta/grpc-connect-client/createConnectQuery'
import { getCustomerQuery } from '@jotta/grpc-connect-client/customer'
import { getAlbum as getAlbumDescriptor } from '@jotta/grpc-connect-openapi/albumQuery'
import { queryClient } from '@jotta/query'

import { getInfiniteAlbumPhotosQueryKey } from '../store/AlbumInfoQueryStore'

export const getAlbumQuery = createConnectQuery(getAlbumDescriptor)

export async function invalidateAlbumQueries(albumId: string) {
  await Promise.allSettled([
    getCustomerQuery.invalidate(),
    getAlbumQuery.invalidate({
      albumIdOrShareId: albumId,
    }),
    queryClient.invalidateQueries({
      queryKey: getInfiniteAlbumPhotosQueryKey({
        albumId,
      }),
    }),
    queryClient.invalidateQueries({ queryKey: ['publicSharedPhotos'] }),
  ])
}

export function useAlbum(albumIdOrShareId: string) {
  return getAlbumQuery({
    variables: {
      albumIdOrShareId,
    },
    enabled: Boolean(albumIdOrShareId),
    select: data => data.album,
  })
}
